import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconInfo = createIcon({
  displayName: 'IconInfo',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M13.5 5.5C13.5 6.32843 12.8284 7 12 7C11.1716 7 10.5 6.32843 10.5 5.5C10.5 4.67157 11.1716 4 12 4C12.8284 4 13.5 4.67157 13.5 5.5ZM13 9V18H16V20H8V18H11V11H9V9H13Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
